
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accelerate/2021/workshops",
      function () {
        return require("private-next-pages/accelerate/2021/workshops/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accelerate/2021/workshops"])
      });
    }
  